// <reference path="../typings.d.ts" />
export { default as Modal } from "./Modal.vue";
export { default as ModalItem } from "./ModalItem.vue";
import { getCurrentInstance } from "vue";
import ModalVue from "./Modal.vue";

export function useDialog() {
  return modalapp.config.globalProperties.$modal;
}

let modalapp: any | null;

export default {
  install: (app) => {
    app.component("Modal", ModalVue);
    modalapp = app;
  }
};
